// extracted by mini-css-extract-plugin
export var copyableField = "_oy-4";
export var customerBadge = "_oy-0";
export var customerInfoTitle = "_oy-2";
export var details = "_oy-1";
export var dropdownContainer = "_oy-5";
export var dropdownImage = "_oy-6";
export var editAssigneeForm = "_oy-a";
export var editButton = "_oy-3";
export var email = "_oy-7";
export var hidden = "_oy-d";
export var input = "_oy-8";
export var saveButton = "_oy-b";
export var shopifyIcon = "_oy-c";
export var suggestionBadge = "_oy-e";
export var suggestionText = "_oy-f";
export var username = "_oy-9";